import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import useAppInsightsHandler from "hooks/useAppInsightsHandler.js";

import { userManualHandler } from "utils/utils";
import { userProfileStrings } from "constants/constantStrings";

import { getUserMenuOptions } from "./UserInfoOptions";
import UserProfileItem from "./UserProfileItem";

import "./index.scss";

const UserInfo = props => {
  const { user } = useSelector(state => state);
  const { onUserDropdownClick } = props;
  const [menuOptions, setMenuOption] = useState([]);
  const objAppInsights = useAppInsightsHandler();

  useEffect(() => {
    const { isAuthorized, hasSystemsAccess, isAdmin } = user;
    const options = getUserMenuOptions(isAuthorized, hasSystemsAccess, isAdmin);
    setMenuOption(options);
  }, []);

  const menuClickHandler = (event, menuOption) => {
    objAppInsights.trackEvent("userMenuOptionClicked");
    if (menuOption === "USER_MANUAL") {
      userManualHandler(event);
    } else {
      onUserDropdownClick();
    }
  };

  const getGroupTemplate = (group, idx) => {
    const { groupName, isVisible, items } = group;
    let template = "";
    if (isVisible) {
      const options = getMenuOptionTemplate(items);
      template = groupName ? (
        <>
          <hr /> <small>{groupName}</small> {options}
        </>
      ) : (
        <>
          <hr /> {options}
        </>
      );
      template = <div key={`OptionGroup${idx}`}>{template}</div>;
    }
    return template;
  };

  const getMenuOptionTemplate = options => {
    let template = "";
    if (options) {
      template = options.map((item, idx) =>
        item.isVisible ? <UserProfileItem {...item} key={`UserMenuOption${idx}`} clickHanlder={menuClickHandler} /> : ""
      );
    }
    return template;
  };
  const getUserRole = () => {
    let role;
    if (user.isAuthorized) {
      role = user.isAdmin
        ? userProfileStrings.administrator
        : user.isTier1
        ? userProfileStrings.tier1
        : user.isTier2
        ? userProfileStrings.tier2
        : userProfileStrings.tier1;
    }
    return role;
  };

  return (
    <div className="user-Modal">
      <div className="user-Container ">
        <span className="user-Name">{user.NickName}</span>
        <span className="user-role pb-1">{getUserRole()}</span>
      </div>
      {menuOptions.map((optionGroup, idx) => getGroupTemplate(optionGroup, idx))}
    </div>
  );
};

export default UserInfo;
